export function capitalize(input: string) {
  if (!input) {
    return "";
  }
  const [fstLetter, ...rest] = input;
  return `${fstLetter.toLocaleUpperCase()}${rest.join("").toLocaleLowerCase()}`;
}
